import { render, staticRenderFns } from "./pagina-nao-encontrada.html?vue&type=template&id=7530f97b&scoped=true&"
import script from "./pagina-nao-encontrada.vue?vue&type=script&lang=js&"
export * from "./pagina-nao-encontrada.vue?vue&type=script&lang=js&"
import style0 from "./pagina-nao-encontrada.less?vue&type=style&index=0&id=7530f97b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7530f97b",
  null
  
)

export default component.exports